export default "__VITE_ASSET__CfRBEZaC__"